import styled from 'styled-components';
import { media } from '../ui/common';
import { colors } from '../../../ui/common';

export const Section = styled.section``;
export const List = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 0 12px;
  color: ${colors.color01};
  ${media.tablet`
      margin: 9px 0 0;
  `}
  ${media.laptop`
      margin: 5px 0 10px;
  `}
`;
export const Block = styled.div`
  width: 50%;
  padding: 14px 0;
  text-align: center;
  box-sizing: border-box;
  ${media.tablet`
    margin-bottom: 36px;
  `}
  ${media.medium`
    width: 25%;
  `}
  ${media.laptop`
    width: 20%;
    margin-bottom: 30px;
    padding: 14px 0;
  `}
`;
export const Text = styled.p`
  display: flex;
  justify-content: center;
  font-weight: 500;
  font-size: 16px;
  max-width: 160px;
  margin: 0 auto;
  line-height: 1.7;
`;
